import { render, staticRenderFns } from "./GlassItem.vue?vue&type=template&id=38b39547&scoped=true&"
import script from "./GlassItem.vue?vue&type=script&lang=js&"
export * from "./GlassItem.vue?vue&type=script&lang=js&"
import style0 from "./GlassItem.vue?vue&type=style&index=0&id=38b39547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b39547",
  null
  
)

export default component.exports